// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import Classnames from "classnames";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";
import * as TextField__Theme$PrezzeeRibbon from "./TextField__Theme.bs.js";
import * as TextField__HelperText$PrezzeeRibbon from "./TextField__HelperText.bs.js";

function cssClass(s) {
  return "." + s + "";
}

var filledLabelSelector = ":not(:placeholder-shown) ~ label";

var filledLegendSelector = ":not(:placeholder-shown) ~ fieldset > legend";

var invalidFieldsetSelector = ":invalid ~ fieldset";

var translateLabel = BsCssJs$PrezzeeRibbon.transforms([
      {
        NAME: "translate",
        VAL: [
          BsCssJs$PrezzeeRibbon.px(7 + TextField__Theme$PrezzeeRibbon.legendOffset | 0),
          BsCssJs$PrezzeeRibbon.px(-13)
        ]
      },
      {
        NAME: "scale",
        VAL: [
          TextField__Theme$PrezzeeRibbon.scaling,
          TextField__Theme$PrezzeeRibbon.scaling
        ]
      }
    ]);

var legendMaxWidth = BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.px(1000));

var label = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.transformOrigin(BsCssJs$PrezzeeRibbon.zero, BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.transform({
            NAME: "translate",
            VAL: [
              BsCssJs$PrezzeeRibbon.px(TextField__Theme$PrezzeeRibbon.horizontalP),
              BsCssJs$PrezzeeRibbon.px(TextField__Theme$PrezzeeRibbon.vertP)
            ]
          }),
      BsCssJs$PrezzeeRibbon.transition(200, 0, {
            NAME: "cubicBezier",
            VAL: [
              0,
              0,
              0.2,
              1
            ]
          }, "transform"),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(TextField__Theme$PrezzeeRibbon.fontS)),
      BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.em(1)),
      BsCssJs$PrezzeeRibbon.pointerEvents("none"),
      BsCssJs$PrezzeeRibbon.zIndex(1),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.px(4))
    ]);

var legend = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pxFloat(0.01)),
      BsCssJs$PrezzeeRibbon.visibility("hidden"),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(5)),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.em(TextField__Theme$PrezzeeRibbon.scaling)),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(11)),
      BsCssJs$PrezzeeRibbon.display("block")
    ]);

function fieldset(theme) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.position("absolute"),
              BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.px(-5)),
              BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.right(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.bottom(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.overflow("hidden"),
              BsCssJs$PrezzeeRibbon.borderWidth(BsCssJs$PrezzeeRibbon.px(1)),
              BsCssJs$PrezzeeRibbon.borderStyle("solid"),
              BsCssJs$PrezzeeRibbon.pointerEvents("none"),
              BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.padding2(BsCssJs$PrezzeeRibbon.zero, BsCssJs$PrezzeeRibbon.px(8)),
              BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius),
              BsCssJs$PrezzeeRibbon.boxSizing("borderBox")
            ]);
}

function fieldsetError(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.borderColor(match.textField.errorColor))]);
}

function input(theme) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.borderStyle("none"),
              BsCssJs$PrezzeeRibbon.background("none"),
              BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.em(1)),
              BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.em(1)),
              BsCssJs$PrezzeeRibbon.paddingTop(BsCssJs$PrezzeeRibbon.px(TextField__Theme$PrezzeeRibbon.vertP)),
              BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(15)),
              BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(TextField__Theme$PrezzeeRibbon.horizontalP)),
              BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(TextField__Theme$PrezzeeRibbon.horizontalP)),
              BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(50)),
              BsCssJs$PrezzeeRibbon.outline(BsCssJs$PrezzeeRibbon.px(0), "solid", "transparent"),
              BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
              BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius),
              BsCssJs$PrezzeeRibbon.selector(filledLabelSelector, [translateLabel]),
              BsCssJs$PrezzeeRibbon.selector(":disabled, :disabled ~ *", [
                    BsCssJs$PrezzeeRibbon.opacity(0.5),
                    BsCssJs$PrezzeeRibbon.hover([BsCssJs$PrezzeeRibbon.cursor("notAllowed")])
                  ])
            ]);
}

function inputInvalidFieldset(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.selector(invalidFieldsetSelector, [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.borderColor(match.textField.errorColor))])]);
}

var inputWithLabel = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.placeholder([BsCssJs$PrezzeeRibbon.color("transparent")]),
      BsCssJs$PrezzeeRibbon.selector("~ fieldset > legend", [BsCssJs$PrezzeeRibbon.children([
                  BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(TextField__Theme$PrezzeeRibbon.legendOffset)),
                  BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(TextField__Theme$PrezzeeRibbon.legendOffset))
                ])]),
      BsCssJs$PrezzeeRibbon.selector(filledLegendSelector, [BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.px(1000))])
    ]);

var innerWrapper = BsCssJs$PrezzeeRibbon.style([
      Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(TextField__Theme$PrezzeeRibbon.fontS)),
      BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.em(1)),
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.display("inlineFlex"),
      BsCssJs$PrezzeeRibbon.flexDirection("column"),
      BsCssJs$PrezzeeRibbon.verticalAlign("top"),
      BsCssJs$PrezzeeRibbon.focusWithin([
            BsCssJs$PrezzeeRibbon.selector(cssClass(legend), [legendMaxWidth]),
            BsCssJs$PrezzeeRibbon.selector(cssClass(label), [translateLabel])
          ])
    ]);

var outerWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("inlineFlex"),
      BsCssJs$PrezzeeRibbon.flexDirection("column")
    ]);

var Styles = {
  translateLabel: translateLabel,
  legendMaxWidth: legendMaxWidth,
  label: label,
  legend: legend,
  fieldset: fieldset,
  fieldsetError: fieldsetError,
  input: input,
  inputInvalidFieldset: inputInvalidFieldset,
  inputWithLabel: inputWithLabel,
  innerWrapper: innerWrapper,
  outerWrapper: outerWrapper
};

function innerWrapper$1(theme) {
  var match = theme.components;
  var light = match.textField.light;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.hover([BsCssJs$PrezzeeRibbon.selector(cssClass(fieldset(theme)), [BsCssJs$PrezzeeRibbon.borderColor(light.hoverBorderColor)])]),
              BsCssJs$PrezzeeRibbon.focusWithin([BsCssJs$PrezzeeRibbon.selector(cssClass(fieldset(theme)), [BsCssJs$PrezzeeRibbon.border(BsCssJs$PrezzeeRibbon.px(1), "solid", light.focusBorderColor)])])
            ]);
}

function input$1(theme) {
  var match = theme.components;
  var light = match.textField.light;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.color(light.color),
              BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.white)),
              BsCssJs$PrezzeeRibbon.placeholder([BsCssJs$PrezzeeRibbon.color(light.placeholderColor)]),
              BsCssJs$PrezzeeRibbon.focus([BsCssJs$PrezzeeRibbon.color(light.color)]),
              BsCssJs$PrezzeeRibbon.selector(":disabled ~ fieldset", [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.borderColor(light.borderColor))]),
              BsCssJs$PrezzeeRibbon.selector(":disabled + label", [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.backgroundColor("transparent"))])
            ]);
}

function fieldset$1(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.borderColor(match.textField.light.borderColor),
              BsCssJs$PrezzeeRibbon.selector("legend", [
                    BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.zero),
                    BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(8))
                  ])
            ]);
}

function label$1(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.color(match.textField.light.placeholderColor),
              BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.white)
            ]);
}

var LightStyles = {
  innerWrapper: innerWrapper$1,
  input: input$1,
  fieldset: fieldset$1,
  label: label$1
};

var transparentWhite = BsCssJs$PrezzeeRibbon.rgba(255, 255, 255, {
      NAME: "num",
      VAL: 0.7
    });

function innerWrapper$2(theme) {
  var match = theme.components;
  var dark = match.textField.dark;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.hover([BsCssJs$PrezzeeRibbon.selector(cssClass(fieldset(theme)), [BsCssJs$PrezzeeRibbon.borderColor(dark.hoverBorderColor)])]),
              BsCssJs$PrezzeeRibbon.focusWithin([BsCssJs$PrezzeeRibbon.selector(cssClass(fieldset(theme)), [
                          BsCssJs$PrezzeeRibbon.border(BsCssJs$PrezzeeRibbon.px(1), "solid", dark.focusBorderColor),
                          BsCssJs$PrezzeeRibbon.filter([{
                                  NAME: "dropShadow",
                                  VAL: [
                                    BsCssJs$PrezzeeRibbon.px(0),
                                    BsCssJs$PrezzeeRibbon.px(0),
                                    BsCssJs$PrezzeeRibbon.px(4),
                                    {
                                      NAME: "rgba",
                                      VAL: [
                                        255,
                                        255,
                                        255,
                                        {
                                          NAME: "num",
                                          VAL: 0.25
                                        }
                                      ]
                                    }
                                  ]
                                }])
                        ])])
            ]);
}

function input$2(theme) {
  var match = theme.components;
  var dark = match.textField.dark;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.color(dark.color),
              BsCssJs$PrezzeeRibbon.placeholder([BsCssJs$PrezzeeRibbon.color(dark.placeholderColor)]),
              BsCssJs$PrezzeeRibbon.focus([BsCssJs$PrezzeeRibbon.color(dark.color)]),
              BsCssJs$PrezzeeRibbon.selector(":disabled ~ fieldset", [BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.borderColor(dark.borderColor))])
            ]);
}

function fieldset$2(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.borderColor(match.textField.dark.borderColor)]);
}

function label$2(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.color(match.textField.dark.placeholderColor)]);
}

var DarkStyles = {
  transparentWhite: transparentWhite,
  innerWrapper: innerWrapper$2,
  input: input$2,
  fieldset: fieldset$2,
  label: label$2
};

function callOption(opt, arg) {
  if (opt !== undefined) {
    return Curry._1(opt, arg);
  }
  
}

function TextField(props) {
  var helperText = props.helperText;
  var error = props.error;
  var type_ = props.type_;
  var theme = props.theme;
  var onFocus = props.onFocus;
  var onBlur = props.onBlur;
  var label$3 = props.label;
  var id = props.id;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var label$4 = label$3 !== undefined ? label$3 : "";
  var theme$1 = theme !== undefined ? theme : /* Light */0;
  var type_$1 = type_ !== undefined ? type_ : "text";
  var error$1 = error !== undefined ? error : false;
  var theme_ = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  var hasLabel = label$4 !== "";
  var placeholderLocal = Belt_Option.getWithDefault(props.placeholder, " ");
  var match = React.useState(function () {
        return false;
      });
  var setDirty = match[1];
  var match$1 = React.useState(function () {
        return false;
      });
  var setBlurred = match$1[1];
  var wrapperStyles = theme$1 ? Classnames([
          innerWrapper,
          innerWrapper$2(theme_)
        ]) : Classnames([
          innerWrapper,
          innerWrapper$1(theme_)
        ]);
  var hasLabelStyle = hasLabel ? inputWithLabel : "";
  var invalidStyle = match[0] && match$1[0] ? inputInvalidFieldset(theme_) : "";
  var inputStyles = theme$1 ? Classnames([
          input(theme_),
          hasLabelStyle,
          input$2(theme_),
          invalidStyle
        ]) : Classnames([
          input(theme_),
          hasLabelStyle,
          input$1(theme_),
          invalidStyle
        ]);
  var labelStyles = theme$1 ? Classnames([
          label,
          label$2(theme_)
        ]) : Classnames([
          label,
          label$1(theme_)
        ]);
  var fieldsetErrorStyle = error$1 ? fieldsetError(theme_) : "";
  var fieldsetStyles = theme$1 ? Classnames([
          fieldset(theme_),
          fieldset$2(theme_),
          fieldsetErrorStyle
        ]) : Classnames([
          fieldset(theme_),
          fieldset$1(theme_),
          fieldsetErrorStyle
        ]);
  var onFocusLocal = function (e) {
    Curry._1(setDirty, (function (param) {
            return true;
          }));
    callOption(onFocus, e);
  };
  var onBlurLocal = function (e) {
    Curry._1(setBlurred, (function (param) {
            return true;
          }));
    callOption(onBlur, e);
  };
  var helperTextElem = helperText !== undefined ? JsxRuntime.jsx(TextField__HelperText$PrezzeeRibbon.make, {
          children: helperText,
          theme: theme$1,
          error: error$1
        }) : null;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("input", {
                              ref: props.inputRef,
                              defaultValue: props.defaultValue,
                              className: inputStyles,
                              id: id,
                              autoComplete: props.autoComplete,
                              autoFocus: props.autoFocus,
                              disabled: props.disabled,
                              form: props.form,
                              maxLength: props.maxLength,
                              minLength: props.minLength,
                              name: props.name,
                              pattern: props.pattern,
                              placeholder: placeholderLocal,
                              readOnly: props.readOnly,
                              required: props.required,
                              size: props.size,
                              type: type_$1,
                              value: props.value,
                              onKeyDown: props.onKeyDown,
                              onKeyUp: props.onKeyUp,
                              onFocus: onFocusLocal,
                              onBlur: onBlurLocal,
                              onChange: props.onChange
                            }),
                        hasLabel ? JsxRuntime.jsx("label", {
                                children: label$4,
                                className: labelStyles,
                                htmlFor: id
                              }) : null,
                        JsxRuntime.jsx("fieldset", {
                              children: JsxRuntime.jsx("legend", {
                                    children: hasLabel ? JsxRuntime.jsx("span", {
                                            children: label$4
                                          }) : null,
                                    className: legend
                                  }),
                              "aria-hidden": true,
                              className: fieldsetStyles
                            })
                      ],
                      className: wrapperStyles
                    }),
                helperTextElem
              ],
              className: Classnames([
                    outerWrapper,
                    className$1
                  ])
            });
}

var HelperText;

var make = TextField;

export {
  HelperText ,
  cssClass ,
  filledLabelSelector ,
  filledLegendSelector ,
  invalidFieldsetSelector ,
  Styles ,
  LightStyles ,
  DarkStyles ,
  callOption ,
  make ,
}
/* translateLabel Not a pure module */
